import React, { useState } from 'react';
import './Youthevent.css';
import Nav from '../Nav'; 
import Navbar from '../Navbar';
import Ye1 from './Ye1';
import Ye2 from './Ye2';
import Ye3 from './Ye3';
import Headimg from '../Headimg';



const Youthevent = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <div> 
      <Nav />
      <Navbar />
      <div style={{marginTop:"90px"}}>
      <Headimg />
      </div>
    <div className="tabspan">
     
      <div className="tabspan-tabs">
        <button
          className={`tabspan-tab ${activeTab === 0 ? 'active' : ''}`}
          onClick={() => handleTabClick(0)}
        >
          Day 1
        </button>
        <button
          className={`tabspan-tab ${activeTab === 1 ? 'active' : ''}`}
          onClick={() => handleTabClick(1)}
        >
          Day 2
        </button>

        <button
          className={`tabspan-tab ${activeTab === 2 ? 'active' : ''}`}
          onClick={() => handleTabClick(2)}
        >
          Day 3
        </button>
       
      </div>

    
       
      </div>
      <div className="tabspan-content">
        {activeTab === 0 && <Ye1 />}
        {activeTab === 1 && <Ye2 />}
        {activeTab === 2 && <Ye3 />}
       

        
      
      </div>
    </div>
    
  );
};

export default Youthevent;
